import { type IApiGeoGetDistrictsTreeResponse } from '@/repositories/generated/shared/monolith-cian-realty/api/geo/get-districts-tree';

import { type IDistrictDirection, type IDistrictTree } from '@/microfrontends/filters/shared/types/districtTree';

const MAX_RECURSION_DEPTH = 10;

// Оставил предохранитель на глубину рекурсии, если попадаются сильно много childs, то это ненормальная ситуация.
// В реальной жизни глубина рекурсии никогда не дойдёт до лимита.
export function prepareDistrictsTree(response: IApiGeoGetDistrictsTreeResponse, recursionLevel = 1): IDistrictTree[] {
  if (recursionLevel >= MAX_RECURSION_DEPTH) {
    throw new Error('[prepareDistrictsTree] maximum recursion depth reached');
  }

  const partialDirections = response.map(item => ({
    ...item,
    name: item.name || '',
    childs: item.childs ? prepareDistrictsTree(item.childs, recursionLevel + 1) : [],
    direction: prepareDirection(item.direction),
  }));

  return partialDirections.filter((item): item is IDistrictTree => !!(item.id && item.type));
}

function prepareDirection(directionRaw: IApiGeoGetDistrictsTreeResponse[number]['direction']): IDistrictDirection {
  return {
    code: directionRaw?.code || null,
    name: directionRaw?.name || null,
  };
}
